import axios from '../utils/axios';

export default function getFunnelAnalysis(adminId, params) {
    return axios.get(`/admin/${adminId}/funnel-analyis`, {
        params
    })
}
